/**
 * Compose a human-readable display name from the split first_name /
 * last_name pair the API now returns. Centralised here so that every
 * screen formats names the same way and a future change (e.g. honoring
 * locale-specific ordering) is a one-line edit.
 */
export interface NameParts {
  first_name?: string | null;
  last_name?: string | null;
}

export function fullName(parts: NameParts | null | undefined): string {
  if (!parts) return '';
  const first = (parts.first_name ?? '').trim();
  const last = (parts.last_name ?? '').trim();
  if (first && last) return `${first} ${last}`;
  return first || last;
}
